var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.739258 9.72675C0.739258 4.70323 4.81163 0.630859 9.83515 0.630859H25.753C30.7765 0.630859 34.8488 4.70323 34.8488 9.72675V25.6446C34.8488 30.6681 30.7765 34.7404 25.753 34.7404H9.83515C4.81163 34.7404 0.739258 30.6681 0.739258 25.6446V9.72675Z",
    fill: "#F3F5FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.357 15.3629C26.6514 15.3629 26.89 15.1238 26.89 14.8289V13.4963C26.89 11.8476 25.9076 10.8633 24.262 10.8633H21.1814V12.5411C21.1551 13.2489 20.1414 13.2483 20.1154 12.5411V10.8633H11.3263C9.68067 10.8633 8.69824 11.8476 8.69824 13.4963V14.829C8.69824 15.1238 8.93687 15.3629 9.2312 15.3629C11.5505 15.4512 11.5494 18.7828 9.23117 18.8705C8.93683 18.8705 8.69824 19.1096 8.69824 19.4045V20.7371C8.69824 22.3858 9.68067 23.3701 11.3263 23.3701H20.1155V21.6923C20.1417 20.9846 21.1554 20.9851 21.1814 21.6923V23.3701H24.262C25.9076 23.3701 26.89 22.3858 26.89 20.7371V19.4045C26.89 19.1096 26.6514 18.8705 26.3571 18.8705C24.0378 18.7823 24.0388 15.4506 26.357 15.3629ZM21.1814 19.4045C21.1551 20.1122 20.1414 20.1117 20.1154 19.4045V18.2606C20.1417 17.5529 21.1554 17.5534 21.1814 18.2606V19.4045ZM21.1814 15.9728C21.1551 16.6806 20.1414 16.68 20.1154 15.9728V14.829C20.1417 14.1212 21.1554 14.1218 21.1814 14.829V15.9728Z",
    fill: "#157FFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingIcon);
export default __webpack_public_path__ + "static/media/booking-icon.fde9d6345b675ce05923b39cdc5a2f21.svg";
export { ForwardRef as ReactComponent };